module.exports = {
  "bg": {
    "position": "fixed",
    "top": 0,
    "bottom": 0,
    "left": 0,
    "right": 0,
    "backgroundColor": "rgba(0,0,0,0.3)"
  },
  "dof-confirm-box-wrap": {
    "backgroundColor": "#ffffff",
    "width": "750",
    "position": "fixed",
    "bottom": 0,
    "borderTopLeftRadius": "32",
    "borderTopRightRadius": "32",
    "overflow": "hidden",
    "transitionDelay": 500
  },
  "@TRANSITION": {
    "dof-confirm-box-wrap": {
      "delay": 500
    }
  },
  "slot-floor": {
    "backgroundColor": "#ffffff",
    "fontSize": "28",
    "borderTopLeftRadius": "32",
    "borderTopRightRadius": "32"
  },
  "row-sb": {
    "flexDirection": "row",
    "justifyContent": "space-between"
  },
  "confirm-buttons": {
    "position": "fixed",
    "bottom": 0,
    "left": 0,
    "right": 0,
    "paddingTop": "16",
    "backgroundColor": "#f2f2f2"
  },
  "left-button": {
    "width": "375",
    "lineHeight": "96",
    "flex": 1,
    "textAlign": "center",
    "backgroundColor": "#ffffff",
    "fontSize": "32",
    "color": "#616C73",
    "borderRightWidth": "1",
    "borderRightColor": "#e5e5e5"
  },
  "right-button": {
    "width": "375",
    "lineHeight": "96",
    "flex": 1,
    "textAlign": "center",
    "backgroundColor": "#ffffff",
    "fontSize": "32",
    "color": "#1E2E37"
  },
  "bottom-offset": {
    "height": "154"
  },
  "bottom-offset-padding": {
    "height": "68"
  },
  "title": {
    "color": "#1E2E37",
    "fontSize": "32",
    "lineHeight": "106",
    "borderBottomColor": "#f2f2f2",
    "borderBottomWidth": "2",
    "borderBottomStyle": "solid",
    "paddingLeft": "32"
  },
  "closeIcon": {
    "position": "absolute",
    "top": "37",
    "right": "37"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-58ad779b!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-confirm-box/index.vue
// module id = 490
// module chunks = 0 1